export const NOTIFICATION_STORE = 'NOTIFICATION_STORE';
export const NOTIFICATION_STORE_SUCCESS = 'NOTIFICATION_STORE_SUCCESS';
export const NOTIFICATION_SEARCH = 'NOTIFICATION_SEARCH';
export const NOTIFICATION_UNREAD = 'NOTIFICATION_UNREAD';
